module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"accept":"Aceptar","alert":"Alerta"},"en":{"accept":"Accept","alert":"Alert"}}')
  delete Component.options._Ctor
}
